import React, { useEffect, useState } from "react";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import "../Styles/style.css";
import ListIcon from "../Asstes/Images/lists-icon.svg";
import config from "../config";

const OrganizationPage = () => {
  const [banner, setBanner] = useState(null);
  const [contents, setContents] = useState([]);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetchBanner();
    fetchContent();
  }, []);

  const fetchBanner = async () => {
    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/banners/organizational-development`
      );
      if (res.data.banners && res.data.banners.length > 0) {
        setBanner(res.data.banners[0]);
      }
    } catch (err) {
      console.error("Error fetching banner:", err);
    }
  };

  const fetchContent = async () => {
    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/content/organizational-development`
      );
      if (res.data.content) {
        setContents(res.data.content);
      }
    } catch (err) {
      console.error("Error fetching content:", err);
    }
  };

  const renderContentSection = (content, index) => {
    const isEven = index % 2 === 0;
    const imgUrl = `/prosapiens-cms/public/${content.content_image}`;

    return (
      <div
        className={isEven ? "text-for-leraning" : "text-lean-img"}
        key={content.id}
        style={{ lineHeight: "1.8" }}
      >
        <div className="image-container">
          {isEven && (
            <div className="image-side" data-aos="fade-right">
              <img src={imgUrl} alt={content.content_title} />
            </div>
          )}
          <div className="text-side" data-aos="fade-left">
            <div dangerouslySetInnerHTML={{ __html: content.content_text }} />
          </div>
          {!isEven && (
            <div className="image-side" data-aos="fade-right">
              <img src={imgUrl} alt={content.content_title} />
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderHighPerformanceCulture = (content) => {
    return (
      <div className="container" key={content.id}>
        <div className="hiring-process">
          <div className="hiring-text">
            {/* Render API HTML exactly as provided */}
            <div
              className="text-side about center-align"
              dangerouslySetInnerHTML={{ __html: content.content_text }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Section 1: Banner */}
      <section className="service-organizational-banner organizational-mobile">
        <div className="overlay container">
          <div className="hero-text">
            <h1>
              {banner
                ? banner.banner_title
                : "Designing Organizations for Growth"}
            </h1>
            <p style={{ color: "#fff" }}>
              {banner ? (
                <span
                  dangerouslySetInnerHTML={{ __html: banner.content_text }}
                />
              ) : (
                "ProSapiens helps you build agile, scalable, and high-performing organizations..."
              )}
            </p>
          </div>
        </div>
      </section>

      {/* Section 2 & 3: Dynamic Content 0 & 1 */}
      <section className="what-we-do">
        <div className="container">
          {contents
            .slice(0, 2)
            .map((content, index) => renderContentSection(content, index))}
        </div>
      </section>

      {/* Section 4: content[2] */}
      {contents[2] && (
        <div className="org">
          <div className="container">
            <div className="image-container">
              <div className="image-side" data-aos="fade-right">
                <img
                  src={`/prosapiens-cms/public/${contents[2].content_image}`}
                  alt="Org Structure"
                />
              </div>
              <div className="text-side" data-aos="fade-left">
                <div className="proSapiens-advantage" />
                <div
                  dangerouslySetInnerHTML={{
                    __html: contents[2].content_text,
                  }}
                />
              </div>
            </div>
          </div>

          {/* Section 5: content[3] */}
          {contents[3] && (
            <div className="container">
              <div className="adv-page-2">
                <div className="image-container">
                  <div className="text-side" data-aos="fade-left">
                    <div className="proSapiens-advantage" />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: contents[3].content_text,
                      }}
                    />
                  </div>
                  <div className="image-side" data-aos="fade-right">
                    <img
                      src={`/prosapiens-cms/public/${contents[3].content_image}`}
                      alt="Org Right-Sizing"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Section 6: High Performance Culture */}
      {contents.map((c) =>
        c.content_order === "5" ? renderHighPerformanceCulture(c) : null
      )}
    </>
  );
};

export default OrganizationPage;
